import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { MpImgPageRoutingModule } from './image-tag-routing.module';

import { MpImgPage } from './image-tag.page';
import { MpImageViewerModule } from 'src/app/shared/components/image-viewer/image-viewer.module';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/app/shared/pipe/pipe.module';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule,
    MpImgPageRoutingModule,
    MpImageViewerModule,
    TranslateModule,
    PipesModule
  ],
  declarations: [MpImgPage],
  exports: [
    MpImgPage
  ]
})
export class MpImgPageModule {}
